import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Contact from "./pages/Book";
import Franchise from "./pages/Franchise";
import ProductPage from "./pages/Products";
import ScrollToTop from "./components/ScrollToTop";
import FAQ from "./pages/FAQ";
import Gallery from "./pages/Gallery";
import Events from "./pages/Events";
import GiftCards from "./pages/GiftCards";
import { LanguageProvider } from "./context/LanguageContext";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <LanguageProvider>
      <HelmetProvider>
        <Router>
          <ScrollToTop />
          <Navbar />
          <div className="Routes">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/products" element={<ProductPage />} />
              <Route path="/franchise" element={<Franchise />} />
              <Route path="/FAQ" element={<FAQ />} />
              <Route path="/Gallery" element={<Gallery />} />
              <Route path="/events" element={<Events />} />
              <Route path="/giftcards" element={<GiftCards />} />
            </Routes>
          </div>
          <Footer />
        </Router>
      </HelmetProvider>
      <CookieBanner />
    </LanguageProvider>
  );
}

export default App;
